export const serverUrl = {
    baseURL: '/adminApi/',//开发走代理
    uploadUrl: '/file/uploadObjectOSS',
    imgUrl: 'https://qifuyun-siyu.oss-cn-shenzhen.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js